import React from 'react';
import { Global } from '@emotion/react';
import bg from '@/assets/questbet/images/backgrounds/bgtop.png';
import footer from '@/assets/questbet/images/backgrounds/footer.png';

export default function index() {
  return (
    <Global
      styles={{
        body: {
          backgroundImage: `url(${bg}), url(${footer}), linear-gradient(180deg, #F7F4E4 40%, #69D0E8 100%)`,
          backgroundPosition: 'center top, center bottom 117px, center',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'contain, contain, cover',
        },
      }}
    />
  );
}
